import Typography from "typography"
import Wordpress2016 from "typography-theme-wordpress-2016"

Wordpress2016.overrideThemeStyles = () => {
  return {
    ".site-title": {
      // color: '#8a00e6'
      // color: '#477eff'
      // color: '#3370ff'
      color: '#ff6200'
    },
    "a.gatsby-resp-image-link": {
      boxShadow: `none`,
    },
    'a': {
      // color: '#477eff'
      color: '#ff6200'
      // color: '#8a00e6'
      // color: '#3370ff'
    },
    'h2,h3,h4,h5,h6': {
      fontFamily: '"Avenir Next", "Helvetica Neue", "Segoe UI", "Helvetica", "Arial", "sans-serif"'
    },
    'h1,h2,h3': {
      // color: '#003ab8'
      color: '#292442'
    },
    'p': {
      color: 'dimgray',
      fontFamily: '"Avenir Next", "Helvetica Neue", "Segoe UI", "Helvetica", "Arial", "sans-serif"',
    },
    'ul,ol': {
      fontFamily: '"Avenir Next", "Helvetica Neue", "Segoe UI", "Helvetica", "Arial", "sans-serif"',
      color: 'dimgray'
    },
    // '.language-javascript': {
    //   background: 'aliceblue'
    // },
    'ol, ul': {
      marginLeft: '40px',
      fontFamily: '"Avenir Next", "Helvetica Neue", "Segoe UI", "Helvetica", "Arial", "sans-serif"'
    },
    'blockquote': {
      marginLeft: 0
    },
    // '.gatsby-code-title': {
    //   fontFamily: '"Avenir Next", "Helvetica Neue", "Segoe UI", "Helvetica", "Arial", "sans-serif"',
    //   display: 'inline-table',
    //   background: '#2d2d2d',
    //   color: 'lightgray',
    //   padding: '12px 16px',
    //   fontSize: '13px',
    //   lineHeight: '13px',
    //   marginBottom: '-8px',
    //   borderBottom: 'solid 4px black',
    //   // marginTop: '16px'
    // },
    '.gatsby-code-title': {
      fontFamily: '"Avenir Next", "Helvetica Neue", "Segoe UI", "Helvetica", "Arial", "sans-serif"',
      display: 'inline-table',
      // background: '#2d2d2d',
      // color: 'lightgray',
      // border: 'solid 4px lightgray',
      boxShadow: 'inset 0 0 0 4px lightgray',
      padding: '12px 16px',
      fontSize: '13px',
      lineHeight: '13px',
      // marginBottom: '-8px',
      marginBottom: '0px',
      // marginBottom: '4px',
      // borderBottom: 'solid 4px black',
      marginTop: '16px'
    },
    '.anchor.after': {
      // display: 'none!important',
      marginLeft: '8px'
    }
  }
}

delete Wordpress2016.googleFonts

const typography = new Typography(Wordpress2016)
// const typography = new Typography({
//   bodyFontFamily: [
//     "Avenir Next",
//     "Helvetica Neue",
//     "Segoe UI",
//     "Helvetica",
//     "Arial",
//     "sans-serif",
//   ]
// })

// Hot reload typography in development.
if (process.env.NODE_ENV !== `production`) {
  typography.injectStyles()
}

export default typography
export const rhythm = typography.rhythm
export const scale = typography.scale
